import { AGENT_WORKFLOW_NAME_MAX_LENGTH } from '@utils/resourceName'

/**
 * Platform-wide limits for agent/workflow name and description (aligned with backend schemas).
 * Name max is re-exported from the canonical agent/workflow naming rule so there is
 * exactly one number to change (`@utils/resourceName`).
 */
export const NAME_MAX_LENGTH = AGENT_WORKFLOW_NAME_MAX_LENGTH

/** Main Agent Studio agent description (markdown docs); 20 * 1024 chars (~20 KB). */
export const MAIN_AGENT_DESCRIPTION_MAX_LENGTH = 20480

/** Canvas sub-agent (AgentNode) inline description; 2^9 chars. */
export const AGENT_NODE_DESCRIPTION_MAX_LENGTH = 512

/** Sticky note node content on agent/workflow canvases; 2^12 chars. */
export const STICKY_NOTE_MAX_LENGTH = 4096

/** Workflow / CWB / Ideate entity descriptions (unchanged; not main-agent docs). */
export const DESCRIPTION_MAX_LENGTH = 256

/** Solutions catalog name limit (aligned with backend SolutionCreate.name max_length). */
export const SOLUTION_NAME_MAX_LENGTH = 255

/** Solutions catalog description limit (aligned with backend SolutionCreate/Update). */
export const SOLUTION_DESCRIPTION_MAX_LENGTH = 2000

/**
 * UI cap for the Solutions catalog "Solution name" input (create/edit dialog).
 * Kept shorter than the backend max (255) for readable catalog names, matching the
 * Agent Studio name limit. Intentionally separate from SOLUTION_NAME_MAX_LENGTH so the
 * clarification "ML solution name" flow (Ideate / Build with AI / Agent Workflows) is unaffected.
 */
export const SOLUTION_NAME_INPUT_MAX_LENGTH = NAME_MAX_LENGTH

/** Master icon edge length (Google Play / common marketplace standard). Stored icons are scaled down to this. */
export const ENTITY_ICON_MAX_PX = 512
/** Max upload size for entity_icons context (matches backend FileService). */
export const ENTITY_ICON_MAX_BYTES = 2 * 1024 * 1024

/**
 * UI cap for workflow Run-with-Parameters `input_data` and node-config textareas.
 * Keeps the editor responsive; backend rejects JSON bodies over 1 MB (HTTP 413).
 */
export const WORKFLOW_JSON_INPUT_MAX_CHARS = 500_000

/** User-facing copy when a workflow JSON request exceeds the 1 MB API limit. */
export const WORKFLOW_PAYLOAD_TOO_LARGE_MESSAGE =
  'Payload too large. Maximum allowed size is 1MB.'

/** HITL node title limit (aligned with backend inbox_items.title VARCHAR(255)). */
export const HITL_NODE_TITLE_MAX_LENGTH = 255

/** HITL node description limit for approval request context. */
export const HITL_NODE_DESCRIPTION_MAX_LENGTH = 2000
